module.exports = __webpack_public_path__ + "img/pencil.9ac675e8.svg";